package co.diena.everything.app.worker.util

import co.diena.everything.api.EntityId
import co.diena.everything.api.EverythingApi
import co.diena.everything.api.EverythingEvent
import co.touchlab.kermit.Logger
import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.map
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.flow.consumeAsFlow
import kotlinx.coroutines.launch
import kotlinx.coroutines.sync.Semaphore
import kotlinx.coroutines.sync.withPermit
import org.lortex.lines.common.AnyError
import org.lortex.lines.common.AnyResult

private val log = Logger.withTag("EntityLoader")

private class LoadEntityRequest(
    val entityId: EntityId,
    val work: suspend () -> Unit,
    var cancelled: Boolean = false,
)

class EntityLoader(
    private val coroutineScope: CoroutineScope,
    private val concurrency: Int = 16,
    private val api: EverythingApi,
    private val lang: String,
) : Loader<EntityId, EverythingEvent> {
    private val queue = Channel<LoadEntityRequest>(capacity = Int.MAX_VALUE)
    private val semaphore = Semaphore(concurrency)

    init {
        coroutineScope.launch {
            coroutineScope {
                try {
                    queue
                        .consumeAsFlow()
                        .collect { loadRequest ->
                            launch {
                                semaphore.withPermit {
                                    /*  AppLogger.i(
                                          "EntityLoader",
                                          "processing ${loadRequest.entityId}"
                                      )*/
                                    if (!loadRequest.cancelled) {
                                        loadRequest.work()
                                    }
                                }
                            }
                        }
                } catch (e: CancellationException) {
                    log.e("queue cancelled: $e")
                }
            }
        }
    }

    /*
    Schedule the load request for this bucket. Cancel the request if it's not already being processed.
     */
    suspend fun loadEntity(
        entityId: EntityId,
    ): AnyResult<EverythingEvent> {
        val result = Channel<AnyResult<EverythingEvent>>()
        val request = LoadEntityRequest(
            entityId = entityId,
            work = {
                runCatching {
                    val events = Ok(api.resolveEvents(listOf(entityId), lang = lang))
                    /*.mapError {
                        AnyError(it).wrap("Failed to resolve entity $entityId")
                    }*/
                    // we expect a single event because there is a single entityId in the request.
                    result.send(events.map { it.first() })
                }.exceptionOrNull()?.let {
                    if (it is CancellationException) {
                        result.cancel(it)
                    } else {
                        log.e("failed to load $entityId: $it")
                        result.send(Err(AnyError(it).wrap("Failed to load entity $entityId")))
                    }
                }
            },
        )

        // AppLogger.i("EntityLoader", "requesting $entityId")
        queue.send(request)

        return try {
            result.receive().also {
                //     AppLogger.i("EntityLoader", "received $entityId -> ${it}")
            }
        } catch (e: CancellationException) {
            //      AppLogger.i("EntityLoader", "request for $entityId cancelled: $e")
            result.cancel()
            request.cancelled = true
            throw e
        }
    }

    override suspend fun load(key: EntityId): AnyResult<EverythingEvent> {
        return loadEntity(key)
    }
}